import React from 'react';
import PropTypes from 'prop-types';

import { useStyles } from '../styles';

function AddOns(props) {
    const { data } = props;
    const classes = useStyles();

    function renderValue() {
        if (data.type === 'onOff') {
            return data.quantity === 1 ? 'ON' : 'OFF';
        }
        return data.quantity;
    }

    return (
        <span className={classes.addOnsPill}>
            {data.name}: {renderValue()}
        </span>
    );
}

AddOns.propTypes = {
    data: PropTypes.object,
};

AddOns.defaultProps = {
    data: {},
};

export default AddOns;
